var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-guide-wrapper',{style:({
    position: 'absolute',
    top: '160px',
    left: `${_vm.nudgeLeft}px`
  }),attrs:{"shaped":"","title":"Report Sheets"}},[_c('v-container',{staticClass:"px-5"},[_c('v-row',[_c('v-col',{staticClass:"body-2 d-flex align-baseline"},[_c('p',{staticClass:"mb-0 align-self-center"},[_vm._v(" Many reports have tabs at the top to click through different sheets. Each of these \"sheets\" contain a different view of the data. ")])])],1)],1),_vm._t("navigator")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }